import { useContext, useRef, useInsertionEffect, useEffect } from "react";
import { PresenceContext } from "../../context/PresenceContext.js";
import { MotionContext } from "../../context/MotionContext/index.js";
import { useIsomorphicLayoutEffect } from "../../utils/use-isomorphic-effect.js";
import { LazyContext } from "../../context/LazyContext.js";
import { MotionConfigContext } from "../../context/MotionConfigContext.js";
import { optimizedAppearDataAttribute } from "../../animation/optimized-appear/data-id.js";
import { microtask } from "../../frameloop/microtask.js";
function useVisualElement(Component, visualState, props, createVisualElement) {
  const { visualElement: parent } = useContext(MotionContext);
  const lazyContext = useContext(LazyContext);
  const presenceContext = useContext(PresenceContext);
  const reducedMotionConfig = useContext(MotionConfigContext).reducedMotion;
  const visualElementRef = useRef();
  createVisualElement = createVisualElement || lazyContext.renderer;
  if (!visualElementRef.current && createVisualElement) {
    visualElementRef.current = createVisualElement(Component, {
      visualState,
      parent,
      props,
      presenceContext,
      blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
      reducedMotionConfig
    });
  }
  const visualElement = visualElementRef.current;
  useInsertionEffect(() => {
    visualElement && visualElement.update(props, presenceContext);
  });
  const wantsHandoff = useRef(Boolean(props[optimizedAppearDataAttribute] && !window.HandoffComplete));
  useIsomorphicLayoutEffect(() => {
    if (!visualElement)
      return;
    microtask.postRender(visualElement.render);
    if (wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
  });
  useEffect(() => {
    if (!visualElement)
      return;
    visualElement.updateFeatures();
    if (!wantsHandoff.current && visualElement.animationState) {
      visualElement.animationState.animateChanges();
    }
    if (wantsHandoff.current) {
      wantsHandoff.current = false;
      window.HandoffComplete = true;
    }
  });
  return visualElement;
}
export {
  useVisualElement
};
//# sourceMappingURL=use-visual-element.js.map
